import Component from 'vue-class-component'
import Vue from 'vue'
import './index.scss'

@Component
export default class Responsibility extends Vue {
  responsibleCategory = []
  confirmationShow = false

  toggleConfirmationShow() {
    this.confirmationShow = true
  }

  render() {
    return (
      <el-dialog visible={true} destroy-on-close
                 custom-class="liability"
                 center>
        <div class='responsibility-content'>
          <div class='responsibility-title-area'>
            <span class='responsibility-title'>定责</span>
          </div>
          <div class='responsibility-close-area'>
            <span class='responsibility-close'>X</span>
          </div>

          <i class='top-left-icon'/>
          <i class='top-right-icon'/>
          <i class='bottom-left-icon'/>
          <i class='bottom-right-icon'/>

          <div class='responsible-category-area'>
            <span class='responsible-title'><span>*</span>定责类目：</span>
            <el-select>
              {
                this.responsibleCategory.map(item =>
                  <el-option key={item.id} label={item.id} value={item.value}/>
                )
              }
            </el-select>
          </div>

          <div class='responsible-person-area'>
            <span class='responsible-person-title'><span>*</span>责任人</span>
            <div class='responsible-person-children'>
              <div class='responsible-person-children-row'>
                <span class='responsible-person-children-title'>当事人1：</span>
                <el-checkbox>有责</el-checkbox>
              </div>
              <div class='responsible-person-children-row'>
                <span class='responsible-person-children-title'>当事人2：</span>
                <el-checkbox>有责</el-checkbox>
              </div>
              <div class='responsible-person-children-row'>
                <span class='responsible-person-children-title'>当事人1：</span>
                <el-checkbox>有责</el-checkbox>
              </div>
              <div class='responsible-person-children-row'>
                <span class='responsible-person-children-title'>当事人2：</span>
                <el-checkbox>有责</el-checkbox>
              </div>
            </div>
            <div class='responsible-submission-area'>
              <span class='responsible-submission'>责任初步意见书.pdf</span>
            </div>
            <div class='responsible-person-btn-area'>
              <span class='responsible-person-btn'>生成意见书</span>
            </div>
          </div>

          <div class='add-accident-certificate-area' v-show={!this.confirmationShow}>
            <span class='add-accident-certificate-btn' onClick={this.toggleConfirmationShow}>添加事故认定书</span>
          </div>

          <div class='accident-certificate-area' v-show={this.confirmationShow}>
            <span class='accident-certificate-title'>当事人1</span>
            <div class='accident-certificate-content'>
              <div class='accident-certificate-content-column'>
                <span class='accident-certificate-content-column-title'><span>*</span>违法条款：</span>
                <el-select>

                </el-select>
              </div>
              <div class='accident-certificate-content-column'>
                <span class='accident-certificate-content-column-title'><span>*</span>责任认定：</span>
                <el-select>

                </el-select>
              </div>
            </div>

            <span class='accident-certificate-title'>当事人1</span>
            <div class='accident-certificate-content'>
              <div class='accident-certificate-content-column'>
                <span class='accident-certificate-content-column-title'><span>*</span>违法条款：</span>
                <el-select>

                </el-select>
              </div>
              <div class='accident-certificate-content-column'>
                <span class='accident-certificate-content-column-title'><span>*</span>责任认定：</span>
                <el-select>

                </el-select>
              </div>
            </div>

            <div class='accident-certificate-btn-area'>
              <span class='accident-certificate-btn'>生成认定书</span>
            </div>
          </div>
        </div>

      </el-dialog>
    )
  }
}
